import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import routes from './routes'
import FourOhFour from './FourOhFour'

/* eslint-disable react/no-array-index-key */
const Template = () => {
  return (
    <Switch>
      <Redirect exact from="/" to="/user" />
      {routes.map( ( route, i ) => {
        const { path, exact, component } = route
        return <Route key={i} path={path} exact={exact} component={component} />
      })}
      <Route component={FourOhFour} />
    </Switch>
  )
}

export default Template
